import { Button } from '@mui/material'
import React, { useState } from 'react'
import { ActionForm } from '../../../Shared/Components/ActionForm/ActionForm'
import { ActionFormContent } from '../../../Shared/Components/ActionForm/ActionFormContent'
import { ActionFormTextField } from '../../../Shared/Components/ActionForm/ActionFormTextField'
import { ActionFormPasswordField } from '../../../Shared/Components/ActionForm/ActionFormPasswordField'
import { ActionFormButtonsContainer } from '../../../Shared/Components/ActionForm/ActionFormButtonsContainer'

export default function LoginForm({ loginWithCredentials, error, goToRegister }) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    function handleSubmit(event) {
        event.preventDefault();
        loginWithCredentials({ email, password })
    }

    const handleEmail = (e) => {
        setEmail(e.target.value)
    }

    const handlePassword = (e) => {
        setPassword(e.target.value)
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center'
        }}>
            <ActionForm handleSubmit={handleSubmit} title='Login'>
                <ActionFormContent>
                    <ActionFormTextField
                        label={'Email'}
                        onChange={handleEmail}
                        value={email}
                        placeholder="your_name@business.com"
                        isRequired={false}
                    />
                    <ActionFormPasswordField
                        label={'Password'}
                        onChange={handlePassword}

                        value={password}
                    />
                </ActionFormContent>
                <ActionFormButtonsContainer>
                    <Button
                        onClick={goToRegister}
                        className='form-button'>
                        Sign Up
                    </Button>
                    <Button type='submit' variant='contained' color="primary">
                        Login
                    </Button>
                </ActionFormButtonsContainer>
            </ActionForm>
        </div>
    )
}
